module.exports = __webpack_public_path__ + "static/img/third2_2_4.99514625.jpg";